import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e4abd0c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1e4abd0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../rem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4abd0c",
  null
  
)

export default component.exports